import { apiClient } from '../client.js';

/**
 * Email Service
 * Handles email operations using Laravel API
 */
export class EmailService {
  constructor() {
    this.client = apiClient;
  }

  /**
   * Send booking confirmation email
   */
  async sendBookingConfirmation(bookingId) {
    return this.client.post('/api/email/booking-confirmation', { booking_id: bookingId });
  }

  /**
   * Send invoice email
   */
  async sendInvoice(invoiceId) {
    return this.client.post('/api/email/invoice', { invoice_id: invoiceId });
  }

  /**
   * Send contact form email
   */
  async sendContactForm(formData) {
    return this.client.post('/api/email/contact', formData);
  }

  /**
   * Send password reset email
   */
  async sendPasswordReset(email) {
    return this.client.post('/api/email/password-reset', { email });
  }

  /**
   * Send custom email
   */
  async sendCustom(templateName, recipientEmail, data) {
    return this.client.post('/api/email/custom', {
      template: templateName,
      email: recipientEmail,
      data
    });
  }

  /**
   * Send notification email
   */
  async sendNotification(type, recipientEmail, data) {
    return this.client.post('/api/email/notification', {
      type,
      email: recipientEmail,
      data
    });
  }
} 